export default {
  fsbo: {
    title: "FSBO Alerts",
    modal: {
      title: "Add FSBO Alert",
      add: "Add",
    },
    common: {
      emptyHeader: "No alerts created",
      emptySubHeader: "Alerts you create will appear here.",
      all: "All",
      buy: "Buy",
      rent: "Rent",
      alertButton: "Create an alert",
      actions: "Actions",
      priceRM: "Price (RM)",
      keywordError: "A maximum of 200 characters is allowed",
      delete: "Delete",
      cancel: "Cancel",
      fsboSelected: "FSBO Alerts selected",
      deletedSuccessfully: "FSBO Alerts successfully deleted",
      addSuccessfully: "FSBO Alerts successfully added",
      allPropertyType: "All Property Type",
      allChannel: "Buy / Rent",
    },
    table: {
      column: {
        type: "Type",
        propertyType: "Property type",
        keyword: "Keyword",
        price: "Price",
        date: "Date",
      },
    },
  },
};
